module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-title-380x245-9c5d2d700ea1ce6d858a03909533fe95.svg";